export default __webpack_public_path__ + "static/100--stacked-column-4922b2814fc85f07b220a15aecb250e9.png";